module.exports = __webpack_public_path__ + "img/bdg_start.13d14192.svg";